var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-button-group',[_c('div',{staticClass:"gl-px-1"},[_c('approve-access-request-button',{attrs:{"member-id":_vm.member.id}})],1),_vm._v(" "),_c('div',{staticClass:"gl-px-1"},[_c('remove-member-button',{attrs:{"member-id":_vm.member.id,"message":_vm.message,"title":_vm.s__('Member|Deny access'),"is-access-request":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }